import React, { useState, useEffect, useCallback } from 'react';
import { useEventTrackerContext } from '../../contexts/EventTracker';
import { usePlaidLink } from 'react-plaid-link';
import { refreshBankTokenConnection } from '../API';

export default function ReconnectPlaid({
  plaidLinkToken,
  account,
  onSuccess = null,
  onExit = null,
}) {
  const { trackEvent } = useEventTrackerContext();

  const onPlaidExit = useCallback(async (error, metadata) => {
    trackEvent({
      event: 'exited_plaid_dialog_when_reconnecting',
      status: metadata?.status,
      error: error,
    });
    if (onExit) onExit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onPlaidSuccess = useCallback(async () => {
    try {
      await refreshBankTokenConnection(account['id']);
      trackEvent({
        event: 're-connected_bank_account',
        account: account.id,
        bank: account['bank'],
      });
      if (onSuccess) onSuccess();
    } catch (error) {}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const config = {
    token: plaidLinkToken,
    onSuccess: onPlaidSuccess,
    onExit: onPlaidExit,
  };

  const plaidDialog = usePlaidLink(config);

  const [opened, setOpened] = useState(false);

  useEffect(() => {
    if (plaidDialog?.ready && !opened) {
      setTimeout(() => {
        setOpened(true);
        plaidDialog.open();
      }, 500);
    }
  }, [plaidDialog, opened]);

  return <div />;
}
